import React, { useState } from 'react';
import { SearchIcon, PlusIcon, EditIcon, TrashIcon, EyeIcon } from 'lucide-react';
import { ServiceDetailModal } from '../components/ServiceDetailModal';
const services = [{
  id: 1,
  name: 'Appliance Repair',
  logo: '🔧',
  location: 'GTA',
  description: 'Technicians will diagnose and advise on the best remedy for your problematic appliances.',
  price: 158.0,
  active: true
}, {
  id: 2,
  name: 'Appraisals',
  logo: '📋',
  location: 'GTA',
  description: 'Need to know the true market value of your home? We can instantly match you with a licensed and seasoned appraiser. It is that simple!',
  price: 470.0,
  active: false
}, {
  id: 3,
  name: 'Carpet Cleaning',
  logo: '🧹',
  location: 'GTA',
  description: 'Carpet cleaning on-site to ensure you get a fast and reliable service. Our Real Estream Pros will make any carpet look new again!',
  price: 189.0,
  active: true
}, {
  id: 4,
  name: 'Duct Cleaning & Antibacterial',
  logo: '💨',
  location: 'GTA',
  description: 'Air Duct Cleaning removes the build-up of common allergens through the cleaning of the furnace truck ducts, floor registers, and central air vents. Resulting in a more efficient air flow and a healthier household environment.',
  price: 373.0,
  active: true
}, {
  id: 5,
  name: 'Electrical',
  logo: '⚡',
  location: 'GTA',
  description: "We know that electrical work requires the expertise of certified electricians. No electrical job is too small! That's why we offer electrical repairs, upgrades, and installation services to meet your needs. Wherever you live, our team of licensed electricians is always just a phone call away! All Real Estream electricians are ESA certified. No after-hour or weekend price difference.",
  price: 105.0,
  active: true
}, {
  id: 6,
  name: 'Exterior Home Cleaning',
  logo: '🏠',
  location: 'GTA',
  description: "Real Estream Pressure Washing Beyond Compare If you're looking for the most qualified and highest-rated pressure washing service, you've come to the correct place. Real Estream Cleaning has the equipment, personnel, and expertise to effectively and professionally complete all types of pressure washing at your home with outstanding outcomes. Our Services: - Pressure Washing - Houses (Brick or Siding) - Driveways - Wood Decks & Fences (Cleaning)",
  price: 735.0,
  active: true
}, {
  id: 7,
  name: 'Handyman Services',
  logo: '🔨',
  location: 'GTA',
  description: 'A handyman is a do-it-all type! We know no job is too small. Your Real Estream Pro Handyman will take care of almost all your general repairs both inside and outside your home! No after-hour or weekend price difference.',
  price: 89.0,
  active: true
}, {
  id: 8,
  name: 'Home Cleaning Services',
  logo: '🧼',
  location: 'GTA',
  description: 'Our Real Estream Pros offer quick, punctual, and professional house cleaning service in the GTA! What we quote is what you pay for. No surprises. Our quotes are based on years of experience and proven skills. Book your first appointment today!',
  price: 190.0,
  active: true
}, {
  id: 9,
  name: 'Home Disinfection',
  logo: '🦠',
  location: 'GTA',
  description: 'Worried about COVID-19 or any other viruses entering your home and want to have peace of mind? Our partners use disinfecting and sanitizing products that are Health Canada Registered and Broad Spectrum Virucidal to ensure the safety of your home or facility. Our deep cleaning and disinfection programs focus on cleaning of high touch points.',
  price: 262.0,
  active: false
}, {
  id: 10,
  name: 'Home Improvement and Renovations',
  logo: '🏗️',
  location: 'GTA',
  description: "Transform Your Living Space with Real Estream Introducing our new service, Home Improvement! Enjoy competitive prices and expert project managers for your home's projects, including: - Basement renovations - Full house renovations - Outdoor interlock or concrete work - Full bathroom revamps - Kitchen remodeling There is a fee of $150 for the full proposal, which will be deducted from the first payment once the proposal is accepted. Additionally, a 3D model will be provided upon acceptance of the proposal. Elevate your home with our professional services!",
  price: 158.0,
  active: true
}];
export const ServicesPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const filteredServices = services.filter(service => service.name.toLowerCase().includes(searchQuery.toLowerCase()) || service.description.toLowerCase().includes(searchQuery.toLowerCase()));
  const handleViewService = service => {
    setSelectedService(service);
    setIsModalOpen(true);
  };
  const handleAddService = () => {
    setSelectedService(null);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedService(null);
  };
  return <div className="p-6 h-full flex flex-col" data-id="element-1011">
      <div className="mb-6" data-id="element-1012">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-1013">Services</h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-1014">
          Manage all available services
        </p>
      </div>
      <div className="bg-white rounded-lg shadow border border-gray-100 flex-1 flex flex-col" data-id="element-1015">
        <div className="p-4 border-b border-gray-200" data-id="element-1016">
          <div className="flex items-center justify-between" data-id="element-1017">
            <div className="flex items-center space-x-2" data-id="element-1018">
              <div className="relative" data-id="element-1019">
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1020" />
                <input type="text" placeholder="Search for something..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 w-80" data-id="element-1021" />
              </div>
            </div>
            <div className="flex items-center space-x-2" data-id="element-1022">
              <button onClick={handleAddService} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm" data-id="element-1023">
                <PlusIcon size={16} className="mr-2" data-id="element-1024" />
                Add Service
              </button>
              <button className="p-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-1025">
                <EditIcon size={16} className="text-gray-600" data-id="element-1026" />
              </button>
              <button className="p-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-1027">
                <TrashIcon size={16} className="text-gray-600" data-id="element-1028" />
              </button>
            </div>
          </div>
        </div>
        <div className="flex-1 overflow-auto" data-id="element-1029">
          <table className="w-full" data-id="element-1030">
            <thead className="bg-gray-50 border-b border-gray-200 sticky top-0" data-id="element-1031">
              <tr data-id="element-1032">
                <th className="px-4 py-3 text-left" data-id="element-1033">
                  <input type="checkbox" className="rounded" data-id="element-1034" />
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1035">
                  Logo
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1036">
                  Name
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1037">
                  Locations
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1038">
                  Description
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1039">
                  Price
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1040">
                  Active
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1041">
                  View
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1042">
              {filteredServices.map(service => <tr key={service.id} className="hover:bg-gray-50" data-id="element-1043">
                  <td className="px-4 py-3" data-id="element-1044">
                    <input type="checkbox" className="rounded" data-id="element-1045" />
                  </td>
                  <td className="px-4 py-3" data-id="element-1046">
                    <div className="h-10 w-10 rounded-lg bg-gray-100 flex items-center justify-center text-2xl" data-id="element-1047">
                      {service.logo}
                    </div>
                  </td>
                  <td className="px-4 py-3" data-id="element-1048">
                    <span className="text-sm font-medium text-gray-900" data-id="element-1049">
                      {service.name}
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-1050">
                    <span className="text-sm text-gray-600" data-id="element-1051">
                      {service.location}
                    </span>
                  </td>
                  <td className="px-4 py-3 max-w-2xl" data-id="element-1052">
                    <p className="text-sm text-gray-600 line-clamp-2" data-id="element-1053">
                      {service.description}
                    </p>
                  </td>
                  <td className="px-4 py-3" data-id="element-1054">
                    <span className="text-sm font-medium text-gray-900" data-id="element-1055">
                      {service.price.toFixed(2)}
                    </span>
                  </td>
                  <td className="px-4 py-3" data-id="element-1056">
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-1057">
                      <input type="checkbox" checked={service.active} className="sr-only peer" readOnly data-id="element-1058" />
                      <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-1059"></div>
                    </label>
                  </td>
                  <td className="px-4 py-3" data-id="element-1060">
                    <button onClick={() => handleViewService(service)} className="p-1 hover:bg-gray-100 rounded text-blue-600" data-id="element-1061">
                      <EyeIcon size={16} data-id="element-1062" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <ServiceDetailModal isOpen={isModalOpen} onClose={handleCloseModal} service={selectedService} data-id="element-1063" />
    </div>;
};